import process from 'process';

import { onSnapshot, types } from 'mobx-state-tree';
import { createContext, useContext } from 'react';

import { getItem, removeItem, setItem } from '../lib/localstorage';

import { User } from './User';
import { Company } from './Company';
import { Attend } from './Attend';
import { Notifiction } from './Notification';
import { NavTabMenus } from './NavTabMenus';
import { AnnuaLeavePlan } from './AnnualleavePlan';
import { AnnualLeavePromotion } from './AnnualLeavePromotion';
import { AnnualLeaveAccrual } from './AnnualLeaveAccrual';
import { CompensationLeave } from './CompensationLeave';
import { ShiftManagement } from './ShiftManagement';
import { CmCodes } from './CmCodes';
import { WorkingFlex } from './WorkingFlex';

const RootModel = types.model({
    user: types.maybe(User),
    company: types.maybeNull(Company),
    attend: types.maybeNull(Attend),
    notifiction: types.maybeNull(Notifiction),
    navtabmenus: types.maybeNull(NavTabMenus),
    anLeavePlan: types.maybeNull(AnnuaLeavePlan),
    annualLeavePromotion: types.maybeNull(AnnualLeavePromotion),
    annualLeaveAccrual: types.maybeNull(AnnualLeaveAccrual),
    compensationLeave: types.maybeNull(CompensationLeave),
    shiftManagement: types.maybeNull(ShiftManagement),
    cmCodes: types.maybeNull(CmCodes),
    workingFlex: types.maybeNull(WorkingFlex),
});

let initialState = RootModel.create({
    user: {},
    company: {},
    attend: {},
    notifiction: {},
    navtabmenus: {},
    anLeavePlan: {},
    annualLeavePromotion: {},
    annualLeaveAccrual: {},
    compensationLeave: {},
    shiftManagement: {},
    cmCodes: {},
    workingFlex: {},
});

if (process.browser) {
    const data = getItem('rootState');
    if (data) {
        const json = JSON.parse(data);
        if (RootModel.is(json)) {
            try {
                // Never restore CompensationLeave UI/filter state across reload
                initialState = RootModel.create({
                    ...json,
                    compensationLeave: {},
                });
            } catch (e) {
                initialState = RootModel.create({
                    user: {},
                    company: {},
                    attend: {},
                    notifiction: {},
                    navtabmenus: {},
                    anLeavePlan: {},
                    annualLeavePromotion: {},
                    annualLeaveAccrual: {},
                    compensationLeave: {},
                    shiftManagement: {},
                    cmCodes: {},
                    workingFlex: {},
                });
            }
        }
    }
}

export const rootStore = initialState;

onSnapshot(rootStore, (snapshot) => {
    //console.log("Snapshot: ", snapshot)
    // Exclude large data arrays from annualLeavePromotion to prevent quota exceeded error
    const snapshotToStore = {
        ...snapshot,
        annualLeavePromotion: snapshot.annualLeavePromotion
            ? {
                  ...snapshot.annualLeavePromotion,
                  restData: [],
                  randomData: [],
                  laborData: [],
                  selectedEmailDetail: [],
                  checkedUsers: [],
                  emailStatusData: [],
              }
            : {},
        annualLeaveAccrual: snapshot.annualLeaveAccrual
            ? {
                  ...snapshot.annualLeaveAccrual,
                  accrualData: [],
                  employeeList: [],
              }
            : {},
        compensationLeave: {},
        shiftManagement: snapshot.shiftManagement
            ? {
                  ...snapshot.shiftManagement,
                  templatesData: [],
                  personnelData: [],
                  patternData: [],
                  checkedTemplates: [],
                  checkedPersonnel: [],
                  checkedPatterns: [],
                  workGroupLists: [],
                  restTypeLists: [],
                  employList: [],
              }
            : {},
        cmCodes: snapshot.cmCodes
            ? {
                  ...snapshot.cmCodes,
                  commonCodes: [],
                  detailCodes: [],
                  attributes: [],
                  deletedCommonCodes: [],
                  deletedDetailCodes: [],
                  deletedAttributes: [],
              }
            : {},
        workingFlex: snapshot.workingFlex
            ? {
                  ...snapshot.workingFlex,
                  workTypeList: [],
              }
            : {},
        anLeavePlan: snapshot.anLeavePlan
            ? {
                  ...snapshot.anLeavePlan,
              }
            : {},
    };
    setItem('rootState', JSON.stringify(snapshotToStore));
});

const RootStoreContext = createContext(null);

export const { Provider } = RootStoreContext;
export const useMst = () => {
    const store = useContext(RootStoreContext);

    if (store === null) {
        throw new Error('Store cannot be null, please add a context provider');
    }
    return store;
};
